/**
 * C3  LINE CHART COMPONENT
 *
 * @version  0.1
 */
import React from 'react';
import { timeFormat } from 'd3';
import { injectIntl } from 'react-intl';
import { isEqual, uniq } from 'lodash';
import api from '../../../pages/StartPage/Dashboard/Dashboard.api';
import utils from '../../../utils/utilities';
import xhr from '../../../utils/xhr';
import C3Chart from './../C3Chart/C3Chart.jsx';

class LineChart extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            spinner: true,
            config: {
                bindto:  '#dashboard-pestle-risk-chart',
                data: {}
            }
        };

        this.loadDashboard = this.loadDashboard.bind(this);
    }

    componentDidMount() {
        this.loadDashboard(this.props.days, this.props.entities, this.props.pestle, this.props.risk, this.props.language);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.days !== nextProps.days ||
            !isEqual(this.props.pestle, nextProps.pestle) ||
            !isEqual(this.props.entities, nextProps.entities) ||
            !isEqual(this.props.language, nextProps.language) ||
            !isEqual(this.props.risk, nextProps.risk)) {
            this.loadDashboard(nextProps.days, nextProps.entities, nextProps.pestle, nextProps.risk, nextProps.language);
        }
    }

    loadDashboard(days, entities, pestle, risk, language) {
        let catFilter = utils.buildDashboardFilter(entities, risk, pestle, days, language);
        api.getPestleRiskData(catFilter)
            .then((response) => {

                let chartColumns = [
                    ['Political'],
                    ['Economic'],
                    ['Social'],
                    ['Technological'],
                    ['Legal'],
                    ['Environmental']
                ];
                let risks = response.body;
                let dateFormat = timeFormat('%b %d');
                let dayObj = {};

                // Sort risks array by date ascending
                risks.sort((risk1, risk2) => {
                    if (risk1.day == risk2.day) {
                        return 0;
                    } else if (risk1.day > risk2.day) {
                        return 1;
                    } else {
                        return -1;
                    }
                });

                for (let i = 0; i < risks.length; i++) {
                    if (!dayObj[risks[i].day]) {
                        dayObj[risks[i].day] = {
                            political: 0,
                            economic: 0,
                            social:0,
                            technological: 0,
                            legal: 0,
                            environmental: 0
                        };
                    }
                    dayObj[risks[i].day][risks[i].pestleCategory] = risks[i].count;
                }

                let allDays = uniq(risks.map(risk => risk.day));

                for (let i = 0; i < allDays.length; i++) {
                    chartColumns[0].push(dayObj[allDays[i]].political);
                    chartColumns[1].push(dayObj[allDays[i]].economic);
                    chartColumns[2].push(dayObj[allDays[i]].social);
                    chartColumns[3].push(dayObj[allDays[i]].technological);
                    chartColumns[4].push(dayObj[allDays[i]].legal);
                    chartColumns[5].push(dayObj[allDays[i]].environmental);
                }

                this.setState({
                    spinner: false,
                    config: {
                        padding: {
                            bottom: 40,
                            top:    30,
                            right:  20
                        },
                        bindto:  '#dashboard-pestle-risk-chart',
                        data: {
                            columns: chartColumns,
                            onclick: this.props.openArticlesOverlay,
                        },
                        tooltip: {
                            grouped: false,
                            format:  {
                                value: function(value, ratio, id, index) {
                                    return id + ' | ' + value + ' Articles';
                                }
                            }
                        },
                        grid:    {y: {show: true}},
                        axis:    {
                            x: {
                                tick: {
                                    culling: false,
                                    rotate:  -45,
                                    format: (i)=> {
                                        let formattedDate = dateFormat(
                                            utils.removeUTCOffset(utils.convertDaysToMilliseconds(allDays[i]))
                                        );
                                        return formattedDate;
                                    }
                                }
                            }

                        }
                    }
                });

            })
            .catch((error) => {
                utils.logError(error, 'DashboardPestleRiskChart.componentWillMount():');
                this.setState({spinner:false});
                xhr.handleAllErrors(error);
            });
    }

    render() {
        return (
            <div>
                {this.state.spinner ? <div className="temporary-loading-spinner" /> : null }
                <C3Chart config={this.state.config} />
            </div>
        );
    }
}

export default injectIntl(LineChart);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Charts/LineChart/LineChart.jsx